import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

export const pill = css`
  appearance: none;
  -webkit-appearance: none;
  margin: 0;
  white-space: nowrap;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: var(${themeVariables.spacing.xs});
  padding: var(${themeVariables.spacing.xs}) var(${themeVariables.spacing.sm});
  border: 1px solid var(${themeVariables.colors.content.secondary});
  border-radius: 100px;
  background-color: var(${themeVariables.colors.surface.default});
  color: var(${themeVariables.colors.content.interactive});
  font-family: var(${themeVariables.typography.body.fontFamily});
  font-weight: var(${themeVariables.typography.body.fontWeight});
  font-size: var(${themeVariables.typography.body.sizes.sm.fontSize});
  line-height: var(${themeVariables.typography.body.sizes.sm.lineHeight});

  &:hover {
    background-color: color-mix(
      in srgb,
      var(${themeVariables.colors.surface.interactive}) 6%,
      white
    );
  }

  &:focus-visible {
    outline: 2px solid var(${themeVariables.colors.stroke.action});
    outline-offset: 2px;
  }

  &[data-active='true'] {
    border-color: color-mix(in srgb, var(${themeVariables.colors.stroke.selected}) 70%, white);
    background-color: color-mix(
      in srgb,
      var(${themeVariables.colors.surface.interactive}) 10%,
      white
    );
    color: var(${themeVariables.colors.content.interactive});
    font-weight: 600;
  }

  &[data-active='true']:hover {
    background-color: color-mix(
      in srgb,
      var(${themeVariables.colors.surface.interactive}) 16%,
      white
    );
  }

  &:disabled {
    cursor: not-allowed;
    border-color: color-mix(in srgb, var(${themeVariables.colors.content.secondary}) 40%, white);
    background-color: var(${themeVariables.colors.page.default});
    color: color-mix(in srgb, var(${themeVariables.colors.content.secondary}) 40%, white);
  }

  &:disabled:hover {
    background-color: var(${themeVariables.colors.page.default});
  }
`;

export const count = css`
  font-weight: 600;
  font-variant-numeric: tabular-nums;
`;
